<div class="mt-4 w-10/12 mx-auto  p-8 flex flex-col gap-1 relative">
  <div class="font-bold text-2xl text-primary">
    Policies and Regulations
  </div>
  <div class="font-normal text-gray-400 text-md">
    Policies and Regulations descriptions
  </div>

  @if (!activeUid) {
    <div class="grid lg:grid-cols-6 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 mt-3 ">
      @for (item of policies$|async; track item) {
        <div (click)="setActiveUid(item)"
             class=" px-8 py-10 flex flex-col items-center gap-2 policy-card intro-x opacity-0 transition-all duration-1000 ease-in-out"
             appInviewPort>
          <div class="flex justify-center items-center">
            <div class="scale-125">
              <mat-icon svgIcon="document_download"></mat-icon>
            </div>
          </div>
          <div class="text-primary font-bold">
            {{ item?.title }}
          </div>
          <div class="text-sm text-gray-400 font-thin">
            {{ item?.description |ellipsis:100 }}
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-1 gap-4 mt-3 ">
      <div class="col-span-1 flex flex-col gap-1">
        @for (item of policies$ |async; track item) {
          <div (click)="setActiveUid(item)"
               class=" px-8 py-10 flex flex-col items-center gap-2 policy-card intro-x opacity-0 transition-all duration-1000 ease-in-out"
               appInviewPort>
            <div class="flex justify-center items-center">
              <div class="scale-125">
                <mat-icon svgIcon="document_download"></mat-icon>
              </div>
            </div>
            <div class="text-primary font-bold">
              {{ item?.title }}
            </div>
            <div class="text-sm text-gray-400 font-thin">
              {{ item?.description |ellipsis:70 }}
            </div>
          </div>
        }
      </div>
      <div class="col-span-1 lg:col-span-5 md:col-span-2 bg-white  px-4 py-10 rounded-2xl" id="viewPoint">
        <div
          class="flex w-full mb-2 items-center gap-2 relative intro-y opacity-0 transition-all duration-1000 ease-in-out"
          appInviewPort>
          <div class="flex justify-center items-center">
            <div class="scale-125">
              <mat-icon svgIcon="document_download"></mat-icon>
            </div>
          </div>
          <div class="flex flex-col gap-2 flex-grow">
            <div class="text-primary font-bold">
              {{ selectedPolicy?.title }}
            </div>
            <div class="text-sm text-gray-400 font-thin">
              {{ selectedPolicy?.description }}
            </div>
          </div>
          <button mat-mini-fab class="!bg-secondary-600 !text-white !shadow-sm"
                  (click)="setActiveUid(null)">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <app-pdf-viewer
          class="w-full"
          [base64Src]="base64String"
          [filenameForDownload]="'Loreem Ipsum'"
        ></app-pdf-viewer>
      </div>
    </div>
  }

</div>
